import elementBase from "./elementBase.js"
import alignementVerticalDefinition from "../definition/alignementVertical.js"
import alignementHorizontalDefinition from "../definition/alignementHorizontal.js"
import fontWeightDefinition from "../definition/fontWeight.js"
import vueStore from "../../config.js"
import * as namespaceStore from "../../namespaceStore.js"

export default class Text extends elementBase {
    objectType = "TextElement";
    _Text = "";
    FontSize = 0;
    FontWeight = undefined;
    VerticalAlignment = undefined;
    HorizontalAlignment = undefined;
    _Foreground = "";
    _Background = "";
    _Police = "";
    PoliceDirectory = null;
    _shadowStyle = "textShadow";
    styleColor = '#1a365d7d'; // Bleu foncé

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }
    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this._Text = args.text ? args.text : "Votre texte ici";
        this.FontSize = args.fontSize ? args.fontSize : 60;
        this.FontWeight = args.fontWeight ? this.getIdFromText(args.fontWeight, fontWeightDefinition) : this.getIdFromText("Normal", fontWeightDefinition);
        if (args.alignment) {
            this.VerticalAlignment = this.getIdFromText(args.alignment, alignementVerticalDefinition);
        }
        else {
            this.VerticalAlignment = args.verticalAlignment ? this.getIdFromText(args.verticalAlignment, alignementVerticalDefinition) : this.getIdFromText("Center", alignementVerticalDefinition);
        }
        this.HorizontalAlignment = args.horizontalAlignment ? this.getIdFromText(args.horizontalAlignment, alignementHorizontalDefinition) : this.getIdFromText("Center", alignementHorizontalDefinition);
        this.Foreground = args.foreground ? args.foreground : "rgba(113, 113, 113, 1)";
        this.Background = args.background ? args.background : "rgba(0, 0, 0, 0)";
        this.Police = args.police ? this.getIdFromText(args.police, vueStore.getters[namespaceStore.THEME + "/ressourcesByType"]("font")) : vueStore.getters[namespaceStore.THEME + "/firstRessourceByType"]("font").idSoft;
    }
    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Text", construct: String, jsType: "String", isVariable: true },
            { property: "FontSize", construct: Number, jsType: "Number" },
            { property: "FontWeight", construct: Number, jsType: "Number" },
            { property: "VerticalAlignment", construct: Number, jsType: "Number" },
            { property: "HorizontalAlignment", construct: Number, jsType: "Number" },
            { property: "PoliceName", construct: String, jsType: "String" },
            { property: "PoliceDirectory", construct: String, jsType: "String", isRessource: true },
            { property: "Foreground", construct: String, jsType: "String" },
            { property: "Background", construct: String, jsType: "String" },
        ];
    }

    get PoliceDesc() {
        const ressource = vueStore.getters[namespaceStore.THEME + "/ressourceByIDSoft"](this._Police);
        if (ressource) {
            return ressource.description;
        }
        return this._Police;
    }

    get PoliceName() {
        const ressource = vueStore.getters[namespaceStore.THEME + "/ressourceByIDSoft"](this._Police);
        if (ressource) {
            return ressource.name;
        }
        return this._Police;
    }

    get Police() {
        return this._Police;
    }

    set Police(value) {
        this._Police = value;
        this.PoliceDirectory = value;
    }

    get addedElementShortCutAction() {
        return [
            ...super.addedElementShortCutAction,
            { name: "Text", text: "Texte afficher", type: "textInput", dataType: "string", description: "Changer le text", svgComponentIcon: "textIcon" },
            { name: "Foreground", text: "Couleur text", type: "colorInput", dataType: "string", description: "Couleur text", svgComponentIcon: "colorIcon" },
        ];
    }
    get shortCut() {
        return [
            ...super.shortCut,
            { name: "Text", text: "Texte afficher", type: "textInput", dataType: "string", description: "Changer le text", svgComponentIcon: "textIcon" },
            { name: "Foreground", text: "Couleur text", type: "colorInput", dataType: "string", description: "Couleur text", svgComponentIcon: "colorIcon" },
        ];
    }

    get Background() {
        return this._Background;
    }

    set Background(value) {
        this._Background = this.harmonizeColorValue(value);
    }

    get Foreground() {
        return this._Foreground;
    }

    set Foreground(value) {
        this._Foreground = this.harmonizeColorValue(value);
    }

    static get Name() {
        return "Texte";
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Text", text: "Texte afficher", type:"textInput", dataType: "string", isVariable: true },
            { name: "FontSize", text: "Taille de la police", type:"numberInput", dataType: "number" },
            { name: "FontWeight", text: "Poids de la police", type:"selectInput", dataType: "string", options: fontWeightDefinition, optionsType: "idSoft" },
            { name: "HorizontalAlignment", text: "Alignement horizontal du texte", type: "selectInput", dataType: "string", options: alignementHorizontalDefinition, optionsType: "idSoft" },
            { name: "VerticalAlignment", text: "Alignement vertical du texte", type: "selectInput", dataType: "string", options: alignementVerticalDefinition, optionsType: "idSoft" },
            { name: "Police", text: "Police de caractères", style: "fontFamily", type: "selectInput", dataType: "string", options: vueStore.getters[namespaceStore.THEME + "/ressourcesByType"]("font"), optionsType: "idSoft" },
            { name: "Foreground", text: "Couleur du texte", type:"colorInput", dataType: "string" },
            //{ name:"Background", text: "Couleur de fond", type:"colorInput", dataType: "string"},
            //{ name:"PoliceDirectory", text: "Chemin de la police", type:"pathInput", dataType: "string"},
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    get FontWeightText() {
        const fontWeight = fontWeightDefinition.find(key => key.idSoft == this.FontWeight);
        return fontWeight.name;
    }
    get FontWeightCssName() {
        const fontWeight = fontWeightDefinition.find(key => key.idSoft == this.FontWeight);
        return fontWeight.cssName;
    }
    get VerticalAlignmentAlignement() {
        return alignementVerticalDefinition.find(key => key.idSoft == this.VerticalAlignment).alignement;
    }
    get HorizontalAlignmentAlignement() {
        return alignementHorizontalDefinition.find(key => key.idSoft == this.HorizontalAlignment).alignement;
    }
    get VerticalAlignmentValue() {
        return alignementVerticalDefinition.find(key => key.idSoft == this.VerticalAlignment).value;
    }
    get HorizontalAlignmentValue() {
        return alignementHorizontalDefinition.find(key => key.idSoft == this.HorizontalAlignment).value;
    }
    get VerticalAlignmentText() {
        const alignment = alignementVerticalDefinition.find(key => key.idSoft == this.VerticalAlignment);
        return alignment.name;
    }
    get HorizontalAlignmentText() {
        const horizontalAlignment = alignementHorizontalDefinition.find(key => key.idSoft == this.HorizontalAlignment);
        return horizontalAlignment.name;
    }
    set Text(value) {
        this._Text = value;
    }
    get Text() {
        // const ressource = vueStore.getters[namespaceStore.THEME + "/ressourceByName"](this._Text);
        // if (ressource) {
        //     return ressource.text;
        // }
        return this._Text;
    }
    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            fontSize: `${this.FontSize}px`,
            fontWeight: `${this.FontWeightCssName}`,
            color: `${this.Foreground}`,
            backgroundColor: `${this.Background}`,
            fontFamily: `${this.PoliceName}`,
            position: 'absolute',
            justifyContent: this.HorizontalAlignmentAlignement,
            alignItems: this.VerticalAlignmentAlignement,
        }
        return style;
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            text: this.valueByVariable(this.Text, variableArray),
            fontSize: this.FontSize,
            fontWeight: this.FontWeightText,
            verticalAlignment: this.VerticalAlignmentValue,
            horizontalAlignment: this.HorizontalAlignmentValue,
            foreground: this.hexColorValue(this.Foreground),
            background: this.hexColorValue(this.Background),
            police: this.PoliceName,
            policeDirectory: '@' + this.PoliceDirectory + '@',
        };
    }
    toObject(minify = false) {
        let object = { 
            ...super.toObject(minify), 
            text: this._Text,
            fontSize: this.FontSize,
            fontWeight: this.FontWeightText,
            verticalAlignment: this.VerticalAlignmentText,
            horizontalAlignment: this.HorizontalAlignmentText,
            foreground: this.Foreground,
            background: this.Background,
            police: this.PoliceName,
        };
        return object;
    }
}

